export enum ROLE {
  ADMINISTRATOR_MANAGER = 'administrator-manager',
  EVENT_MANAGER = 'event-manager',
  RESULTS_MANAGER = 'results-manager',
  USER_MANAGER = 'user-manager',
  VENUE_MANAGER = 'venue-manager',
}
